<template>
  <button class="rounded-[5px] bg-black text-white inline-block font-regular font-text text-body-m px-4 py-2 transition-all hover:bg-blue-500">
    <slot />
  </button>
</template>
